
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import { BrowserRouter } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from './components/ui/toaster'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

// Configure error handler for chunk loading failures
window.addEventListener('error', (event) => {
  // Check if this is a chunk loading error
  if (event.message && 
      (event.message.includes('Failed to fetch dynamically imported module') || 
       event.message.includes('Loading chunk') || 
       event.message.includes('Loading CSS chunk'))) {
    
    console.error('Chunk loading error detected:', event);
    
    // Show user-friendly message
    const errorElement = document.createElement('div');
    errorElement.style.position = 'fixed';
    errorElement.style.top = '0';
    errorElement.style.left = '0';
    errorElement.style.width = '100%';
    errorElement.style.padding = '1rem';
    errorElement.style.backgroundColor = '#f44336';
    errorElement.style.color = 'white';
    errorElement.style.textAlign = 'center';
    errorElement.style.zIndex = '9999';
    errorElement.textContent = 'Failed to load application resources. Please refresh the page.';
    
    document.body.prepend(errorElement);
    
    // Add refresh button
    const refreshButton = document.createElement('button');
    refreshButton.textContent = 'Refresh Now';
    refreshButton.style.marginLeft = '1rem';
    refreshButton.style.padding = '0.25rem 0.5rem';
    refreshButton.style.backgroundColor = 'white';
    refreshButton.style.color = '#f44336';
    refreshButton.style.border = 'none';
    refreshButton.style.borderRadius = '0.25rem';
    refreshButton.style.cursor = 'pointer';
    refreshButton.onclick = () => window.location.reload();
    
    errorElement.appendChild(refreshButton);
  }
});

// Create a client with improved error handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30000, // 30 seconds
      meta: {
        onError: (error: Error) => {
          console.error('Query error:', error);
        }
      }
    },
  },
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <App />
          <Toaster />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
)
